import React, { useState } from "react";
import { Toaster } from "./components/ui/Sonner";
import { Screen } from "./components/common/GovShell";
import { PublicHome } from "./pages/PublicHome";
import { AuthPage, CitizenDashboard } from "./pages/AuthCitizen";
import { ApplicationFlow } from "./pages/ApplicationFlow";
import { CorrectionPage, PropertySearch, Receipt, Tracking } from "./pages/Tracking";
import { AdminDetail, ApplicationQueue } from "./pages/AdminWorkspaces";
import { Registry } from "./pages/RegistryReports";
import { AnalyticsDashboard, AnalyticsReportCenter } from "./pages/Analytics";
export function App() {
  const [screen, setScreen] = useState<Screen>("home");
  const route = () => {
    switch (screen) {
      case "home":
        return <PublicHome screen={screen} setScreen={setScreen} data-id="element-0" data-mp="2wip6b2g4hi4x" />;
      case "auth":
        return <AuthPage screen={screen} setScreen={setScreen} data-id="element-1" data-mp="28t4j27cxrypu" />;
      case "citizen":
        return <CitizenDashboard screen={screen} setScreen={setScreen} data-id="element-2" data-mp="23u9vyt7xrnzx" />;
      case "application":
        return <ApplicationFlow screen={screen} setScreen={setScreen} data-id="element-3" data-mp="3iiwaeb4natww" />;
      case "receipt":
        return <Receipt screen={screen} setScreen={setScreen} data-id="element-4" data-mp="3mkhn9wh6j873" />;
      case "tracking":
        return <Tracking screen={screen} setScreen={setScreen} data-id="element-5" data-mp="3rbzlwdvqcwow" />;
      case "correction":
        return <CorrectionPage screen={screen} setScreen={setScreen} data-id="element-6" data-mp="6hovayao7c0" />;
      case "propertySearch":
        return <PropertySearch screen={screen} setScreen={setScreen} data-id="element-7" data-mp="2zlld2w2kqak3" />;
      case "adminDistrict":
        return <AnalyticsDashboard screen={screen} setScreen={setScreen} variant="district" data-id="element-8" data-mp="33m5eibu6k0c1" />;
      case "adminDivision":
        return <AnalyticsDashboard screen={screen} setScreen={setScreen} variant="division" data-id="element-9" data-mp="38l053zye2t6p" />;
      case "adminHead":
        return <AnalyticsDashboard screen={screen} setScreen={setScreen} variant="head" data-id="element-10" data-mp="3dm5xtxs1ugg8" />;
      case "adminQueue":
        return <ApplicationQueue screen={screen} setScreen={setScreen} data-id="element-11" data-mp="nxn9e3f6jnsn" />;
      case "adminDetail":
        return <AdminDetail screen={screen} setScreen={setScreen} data-id="element-12" data-mp="swgkxqawp4q6" />;
      case "registry":
        return <Registry screen={screen} setScreen={setScreen} data-id="element-13" data-mp="38kxclxdi5kq" />;
      case "reports":
        return <AnalyticsReportCenter screen={screen} setScreen={setScreen} data-id="element-14" data-mp="3ucjcxuxf2du9" />;
      default:
        return <PublicHome screen="home" setScreen={setScreen} data-id="element-15" data-mp="d45ua5nl4fnm" />;
    }
  };
  return <><a href="#main-content" className="skip-link" data-id="element-16" data-mp="86mfn4mz60v5">মূল কনটেন্টে যান</a><div id="main-content" data-id="element-17" data-mp="3gle9siuub3f6">{route()}</div><Toaster position="bottom-right" richColors data-id="element-18" data-mp="3gmfu7dxqx29k" /></>;
}